import React, { FC, PropsWithChildren } from 'react';
import { Form } from 'antd';
import { isValidForm } from '@core/utils/methods';
import { AddOrEditModal } from '@shared/components';
import { TextArea } from '@shared/modules';
import { DisablingModalProps } from './models';

import './styles.scss';

const { useForm } = Form;

export const DisablingModal: FC<DisablingModalProps> = ({
  fieldSetter,
  visible,
  modalType,
  toggleModal,
}: PropsWithChildren<DisablingModalProps>) => {
  const [form] = useForm();

  const add = async (): Promise<void> => {
    if (await isValidForm(form)) {
      fieldSetter(form.getFieldValue('disablingNote'));
      form.resetFields();
    }
  };

  return (
    <AddOrEditModal
      onOk={add}
      onCancel={(): void => {
        toggleModal(modalType);
        form.resetFields();
      }}
      visible={visible}
      type={modalType}
      title="Disabling Notes"
      okText="Add"
      cancelText="Cancel"
      className="prov-site-information-disabling-modal"
      formProps={{
        labelCol: { span: 6 },
        wrapperCol: { span: 15 },
        form,
      }}
      forceRender={false}
    >
      <TextArea
        id="disablingNote"
        label="Disabling Notes"
        formItemProps={{
          rules: [{ required: true, message: 'Disabling Notes is required!' }],
        }}
      />
    </AddOrEditModal>
  );
};
